export default {
    kebab: (string) => string
        .replace(new RegExp(' ','g'), '-')
        .replace(new RegExp('_','g'), '-')
        .toLowerCase(),
    snake: (string) => string
        .replace(new RegExp(' ','g'), '_')
        .replace(new RegExp('-','g'), '_')
        .toLowerCase(),
    capitalize: (string) => string.charAt(0).toUpperCase() + string.slice(1),
    hasValue: (val) => {
        if (val == undefined)
            return false;

        return /(.|\s)*\S(.|\s)*/.test(val);
    },
    truncate: (val, length = 25) => val.length > length ? `${val.slice(0, length - 3)}...` : val
};